import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { ChimieService, Chimie } from '../../../services/chimie.service';

@Component({
  selector: 'app-modifier-chimie',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './modifier-chimie.component.html',
  styleUrl: './modifier-chimie.component.scss'
})
export class ModifierChimieComponent implements OnInit {
  nom = '';
  id: number | null = null;
  chimies: Chimie[] = [];
  error = '';
  success = '';
  loading = false;

  constructor(
    private readonly chimieService: ChimieService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.id = params['id'] ? Number(params['id']) : null;
      this.loadSelectedChimie();
    });
    this.chimieService.list().subscribe({
      next: (chimies) => {
        this.chimies = chimies;
        this.cdr.detectChanges();
      },
      error: () => {
        this.chimies = [];
        this.cdr.detectChanges();
      }
    });
  }

  onSelectChange(): void {
    this.loadSelectedChimie();
  }

  private loadSelectedChimie(): void {
    if (this.id) {
      this.chimieService.get(this.id).subscribe({
        next: (chimie: Chimie) => {
          this.nom = chimie.nom;
          this.cdr.detectChanges();
        },
        error: () => {
          this.error = 'Erreur lors du chargement.';
          this.cdr.detectChanges();
        }
      });
    } else {
      this.nom = '';
      this.cdr.detectChanges();
    }
  }

  update(): void {
    if (!this.id) return;
    this.error = '';
    this.success = '';
    this.loading = true;
    this.chimieService.update(this.id, { nom: this.nom }).subscribe({
      next: () => {
        this.success = 'Chimie modifiée.';
        this.loading = false;
        // Recharge la liste pour mettre à jour la dropdown
        this.chimieService.list().subscribe({
          next: (chimies) => {
            this.chimies = chimies;
            this.cdr.detectChanges();
          },
          error: () => {
            this.cdr.detectChanges();
          }
        });
        this.cdr.detectChanges();
      },
      error: () => {
        this.error = 'Erreur lors de la modification.';
        this.loading = false;
        this.cdr.detectChanges();
      }
    });
  }
}
